import React from 'react';
import { stringify } from 'query-string';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getOptions } from '../selectors/options';
import { getAllCitiesIds, getAllCensusTractsIds } from '../selectors/locations';

const QuerySync = ({ options, allCitiesIds, allCensusTractsIds }) => {
  const { selectedCitiesIds, selectedCensusTractsIds, ...rest } = options;

  const queryState = {
    selectedCitiesIds:
      selectedCitiesIds.length === allCitiesIds.length
        ? null
        : selectedCitiesIds,

    selectedCensusTractsIds:
      selectedCensusTractsIds.length === allCensusTractsIds.length
        ? null
        : selectedCensusTractsIds,

    ...rest,
  };

  return (
    <Redirect
      to={{ search: stringify(queryState, { arrayFormat: 'brackets' }) }}
    />
  );
};

export default connect(state => ({
  options: getOptions(state),
  allCitiesIds: getAllCitiesIds(state),
  allCensusTractsIds: getAllCensusTractsIds(state),
}))(QuerySync);



// WEBPACK FOOTER //
// ./src/components/QuerySync.jsx